import { render, staticRenderFns } from "./salesmanDetail.vue?vue&type=template&id=be565c64&scoped=true&"
import script from "./salesmanDetail.vue?vue&type=script&lang=js&"
export * from "./salesmanDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesmanDetail.vue?vue&type=style&index=0&id=be565c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be565c64",
  null
  
)

export default component.exports